/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Anonymization algorithms for anonymized grading.
 */
export const AssignmentAnonymizationAlgo = /* #__PURE__ */ parsers.exactly('murmur_v3');
